<h3 mat-dialog-title>{{ data.title }}</h3>
<div mat-dialog-content class="padding-bottom-sm">
  <input
    matInput
    #input
    [value]="inputValue"
    (change)="onInputChange(input)"
    (input)="inputValue = $event.target.value"
    type="number"
    placeholder="Offer rate"
    required
    />
</div>

<div mat-dialog-actions >
  @for (action of data.actions; track action; let isFirst = $first) {
    <button
      mat-raised-button
      [disabled]="action.disabled || (!inputValue && isFirst)"
      [color]="action.color"
      (click)="action.action(inputValue)"
      >
      {{ action.name }}
    </button>
  }
</div>
